import React, { useState } from "react";
import StarIcon from "@mui/icons-material/Star";
import Rating from "@mui/material/Rating";
import ProductReviews from "./ProductReviews";

const ReviewSection = () => {
  const totalRatings = 249;
  const averageRating = 4.5;
  const ratings = [
    { stars: 5, count: 180 },
    { stars: 4, count: 69 },
    { stars: 3, count: 0 },
    { stars: 2, count: 0 },
    { stars: 1, count: 0 },
  ];
  const [openDialog, setOpenDialog] = useState(false);
  return (
    <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto sm:px-5 md:px-0 md:py-16 pt-9">
      <h2
        className="md:text-[55px] text-[28px] font-lexend md:font-extralight font-light md:mb-2 mb-4 text-[#24522f] md:text-left text-center"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        Reviews
      </h2>
      <div className="md:grid hidden grid-cols-2 xl:grid-cols-3 gap-y-9 justify-between items-center">
        {/* Left Section */}
        <div className="text-[#24522f]">
          <h3 className="md:text-[74px] text-[33px] font-lexend font-light md:font-extralight tracking-wider">
            {averageRating}
          </h3>
          <Rating
            name="product-rating"
            value={averageRating}
            precision={0.5}
            readOnly
            icon={
              <StarIcon
                sx={{ color: "#f2e390", fontSize: "40px" }}
                className="text-sm md:text-[40px]"
              />
            }
            emptyIcon={
              <StarIcon
                sx={{ opacity: 0.3, fontSize: "40px" }}
                className="text-sm md:text-[40px]"
              />
            }
          />
          <p className="font-lexend font-light md:text-[20px] sm:text-xs">
            {totalRatings} Ratings
          </p>
        </div>

        {/* Rating Breakdown */}
        <div className="">
          {ratings.map((rating) => (
            <div key={rating.stars} className="flex items-center gap-4">
              {/* Fixed-width star container */}
              <div className="flex items-center w-[150px] justify-start">
                {[...Array(rating.stars)].map((_, i) => (
                  <StarIcon
                    key={i}
                    sx={{
                      color: "#f2e390",
                      fontSize: "26px",
                    }}
                    className="text-sm md:text-[26px]"
                  />
                ))}
              </div>

              {/* Progress bar with reduced width */}
              <div className="w-[200px] bg-[#ede6d4] h-[5px] rounded overflow-hidden">
                <div
                  className="h-full bg-[#c5b895]"
                  style={{
                    width: `${(rating.count / totalRatings) * 100}%`,
                  }}
                ></div>
              </div>

              {/* Count */}
              <span className="text-[#24522f] font-lexend font-light text-[15px] text-left w-[35px]">
                {rating.count}
              </span>
            </div>
          ))}
        </div>
        <div className="w-full mx-auto flex justify-end items-center">
          <button
            onClick={() => {
              setOpenDialog(true);
            }}
            className="relative px-5 py-3 w-full xl:w-[63%] xl:text-[22px] sm:text-xl uppercase font-normal font-lexend shadow tracking-wider   bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[22px]"
          >
            Write A Review
          </button>
        </div>
      </div>

      {/* For the Mobile Screen Sizes */}
      <div className="md:hidden  flex gap-y-9 items-center justify-center sm:gap-8 gap-16 xs:gap-8 xxs:gap-4">
        {/* Left Section */}
        <div className="text-[#24522f]">
          <h3 className=" sm:text-[33px] text-[40px] font-lexend font-light md:font-extralight tracking-wider">
            {averageRating}
          </h3>
          <Rating
            name="product-rating"
            value={averageRating}
            precision={0.5}
            readOnly
            icon={
              <StarIcon
                sx={{ color: "#f2e390", fontSize: "40px" }}
                className="xs:text-sm text-base "
              />
            }
            emptyIcon={
              <StarIcon
                sx={{ opacity: 0.3, fontSize: "40px" }}
                className="xs:text-sm text-base"
              />
            }
          />
          <p className="font-lexend font-light md:text-[20px] xs:text-xs text-sm">
            {totalRatings} Ratings
          </p>
        </div>

        {/* Rating Breakdown */}
        <div className="">
          {ratings.map((rating) => (
            <div
              key={rating.stars}
              className="flex items-center xs:gap-0 sm:gap-2 gap-6"
            >
              {/* Fixed-width star container */}
              <div className="flex items-center xs:w-[50px] sm:w-16 w-20 justify-start mr-6">
                {[...Array(rating.stars)].map((_, i) => (
                  <StarIcon
                    key={i}
                    sx={{
                      color: "#f2e390",
                      fontSize: "26px",
                    }}
                    className="text-sm md:text-[26px]"
                  />
                ))}
              </div>

              {/* Progress bar with reduced width */}
              <div className="w-28 xs:w-16 bg-[#ede6d4] h-[5px] rounded overflow-hidden">
                <div
                  className="h-full bg-[#c5b895]"
                  style={{
                    width: `${(rating.count / totalRatings) * 100}%`,
                  }}
                ></div>
              </div>

              {/* Count */}
              <span className="text-[#24522f] font-lexend font-light xs:text-xs text-[15px] text-left w-[35px] ps-4">
                {rating.count}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full mx-auto md:hidden flex justify-center items-center py-8">
        <button
          onClick={() => {
            setOpenDialog(true);
          }}
          className="relative px-5 sm:py-1.5 sm:px-3 py-3 xs:w-[180px] dm:w-full xl:w-[63%] xs:text-[16px] xl:text-[22px] sm:text-xl uppercase font-normal font-lexend shadow tracking-wider   bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal sm:hover:text-[16px] hover:text-[22px]"
        >
          Write A Review
        </button>
      </div>
      <ProductReviews
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
      />
    </div>
  );
};

export default ReviewSection;
